import React, { FormEventHandler } from 'react';
import { useState } from 'react';

import firebase from 'firebase/app';

import { useCollection, useCollectionData, useDocumentData } from 'react-firebase-hooks/firestore';

// ---------- In project imports ----------

import { auth, firestore, functions, FieldValue } from './initFirebase';
import { LineInput, Button, Modal, VGap } from './UI';
import RoomList from './RoomList';
import Room from './Room';

import Styles from './Main.module.scss';
import discordLogoSrc from './images/Discord_Logo_Wordmark_Black.svg';
import discordLogoData from './images/Discord_Logo_Wordmark_Black';


const createAndJoinRoom = functions.httpsCallable('createAndJoinRoom');
const joinRoom = functions.httpsCallable('joinRoom');


function GameScreen(
	{ user, isAdmin } :
	{
		user: firebase.User,
		isAdmin: boolean,
	}
) {
	const [currentRoomId, setCurrentRoomId] = useState<string | null>(null);
	const [roomsModalOpen, setRoomsModalOpen] = useState(false);

	const [joinRoomId, setJoinRoomId] = useState('');
	const [newRoomName, setNewRoomName] = useState('');
	const [joinNickname, setJoinNickname] = useState('');


	// TODO: deprecate roomId ?
	const roomId = currentRoomId ?? 'dummy';
	
	async function createAndJoinRoomTriggered(e: React.FormEvent) {
		e.preventDefault();

		try {
			const newRoomId = await createAndJoinRoom({ name: newRoomName, nickname: joinNickname });
			setRoomsModalOpen(false);
			setCurrentRoomId(newRoomId.data);
		} catch (error) {
			console.error(error);
			window.alert(JSON.stringify(error));
		}
	}

	async function joinRoomTriggered(e: React.FormEvent) {
		e.preventDefault();

		try {
			await joinRoom({ roomId: joinRoomId, nickname: joinNickname });
			setRoomsModalOpen(false);
			setCurrentRoomId(joinRoomId.trim());
		} catch (error) {
			console.error(error);
			window.alert(JSON.stringify(error));
		}
	}

	const extraDebugInfo = false;

	return <div className={Styles.gameContainer}>
		<div className={Styles.menu}>
			{user == null
			? <h2>Would you please log in?</h2>
			:
			<>
				<img src={discordLogoData} style={{ width: '100%' }} />
				<p>
					Join game's official Discord to discuss it, find team-mates or anything else: <br />
					<a href="https://discord.com/invite/f5XpW3k89v" target="_blank">discord.com/invite/f5XpW3k89v</a>
				</p>
				<p>
					Read <b>rules</b> on itch.io page: <br />
					<a href="https://nns2009.itch.io/tank-tactics" target="_blank">nns2009.itch.io/tank-tactics</a>
				</p>

				{extraDebugInfo &&
				<>
					<h2>User</h2>
					<p><b>UID</b>: {user.uid.substr(0, 7)}...</p>
					<p>{user.displayName}</p>
					<p>{user.email}</p>
				</>}
				{isAdmin && <div className={Styles.adminNotice}>Admin mode</div>}
				<p><Button label="Log out" onClick={() => auth.signOut()} /></p>
				<h2>My Rooms</h2>
				<RoomList
					currentRoomId={currentRoomId}
					setCurrentRoomId={setCurrentRoomId}
					roomsCollection={
						firestore
						.collection('roomStates')
						// .where(`users.${user.uid}`, '!=', null)
						// .orderBy(`users.${user.uid}`, 'asc')
						// .orderBy('createdAt', 'asc')
						.where(`users.${user.uid}.joinedAt`, '!=', null)
						.orderBy(`users.${user.uid}.joinedAt`, 'asc')
					}
				/>
				{isAdmin && <>
					<h2>All Rooms:</h2>
					<RoomList
						currentRoomId={currentRoomId}
						setCurrentRoomId={setCurrentRoomId}
						roomsCollection={
							firestore
							.collection('roomStates')
							.orderBy('createdAt', 'asc')
						}	
					/>
				</>}

				{extraDebugInfo &&
				<p>Current room: {currentRoomId}</p>
				}

				<VGap />
				<Button label="Create or join" onClick={() => setRoomsModalOpen(true)} />

				{roomsModalOpen &&
				<Modal>
					<Button label="Close" onClick={() => setRoomsModalOpen(false)} />
					<div style={{ maxWidth: '400px' }}>
						<p>
							This is slow-paced game. Please <b>only join or create room if you can commit to playing the game for it's full duration</b> (which, once again, will probably take a couple weeks).
						</p>
						<p>
							If you are just curious how it will play out, subscribe to <a href="https://youtu.be/aP9eKrnyxe4" target="_blank">my YouTube channel</a> where I'll make a video about making this game and how the actual gameplay went.
						</p>
						<p>
							Check out the top of game's Itch.io page to find public Room ID and play with strangers. Note: it will take some time (likely a couple of days) before the necessary number of players join, so don't expect the game to begin right away.
						</p>
						<p>
							Or create a room and play with your friends. Only people with Room ID would be able to join, so you can invite just those who you want.
						</p>
					</div>
					<h2>Join room</h2>
					<form onSubmit={joinRoomTriggered}>
						<div>
							Room ID: <LineInput value={joinRoomId} onChange={setJoinRoomId} />
						</div>
						<div>
							Nickname in room: <LineInput value={joinNickname} onChange={setJoinNickname} />
						</div>
						<VGap />
						<Button label="Join" />
					</form>

					<h2>Create room</h2>
					<form onSubmit={createAndJoinRoomTriggered}>
						<div>
							Room name: <LineInput value={newRoomName} onChange={setNewRoomName} />
						</div>
						<div>
							Nickname in room: <LineInput value={joinNickname} onChange={setJoinNickname} />
						</div>
						<VGap />
						<Button label="Create" />
					</form>
				</Modal>}

			</>
			}
		</div>

		{currentRoomId !== null && user != null
		&& <Room id={currentRoomId} user={user} isAdmin={isAdmin} />}

	</div>;
}

export default GameScreen;
